import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { OhVueIcon, addIcons } from 'oh-vue-icons';
import {
  FaInfoCircle,
  FaCheckCircle,
  FaTimesCircle,
  FaTrash,
  FaExclamationCircle,
  FaTimes,
  CoPlus,
  FaGamepad,
  CoHome,
  GiSoapExperiment,
  OiGear,
  HiLogout,
  MdCancelTwotone,
  GiConfirmed,
} from 'oh-vue-icons/icons';

import App from './App.vue';
import router from './router';

import './assets/main.css';

addIcons(
  FaTrash,
  FaInfoCircle,
  FaCheckCircle,
  FaTimesCircle,
  FaExclamationCircle,
  FaTimes,
  FaGamepad,
  CoPlus,
  CoHome,
  GiSoapExperiment,
  OiGear,
  HiLogout,
  MdCancelTwotone,
  GiConfirmed,
);

const app = createApp(App);

app.use(createPinia());
app.use(router);

app.component('v-icon', OhVueIcon);

app.mount('#app');
